
import { Toaster } from "@/components/ui/toaster";
import RiderEventSelectWeBelongHereMiami from "./pages/RiderEventSelectWeBelongHereMiami";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import DriverLanding from "./pages/DriverLanding";
import NotFound from "./pages/NotFound";
import Register from "./pages/Register";
import RegisterNew from "./pages/RegisterNew";
import Login from "./pages/Login";
import Verify from "./pages/Verify";
import VehicleRegistration from "./pages/VehicleRegistration";
import Dashboard from "./pages/Dashboard";
import Account from "./pages/Account";
import DriverTripSync from "./pages/DriverTripSync";
import RiderEventSelect from "./pages/RiderEventSelect";
import RiderEventSelectBreakaway from "./pages/RiderEventSelectBreakaway";
import RiderEventSelectBreakawayV2 from "./pages/RiderEventSelectBreakawayV2";
import RiderEventSelectFisher1 from "./pages/RiderEventSelectFisher1";
import RiderEventSelectTest1 from "./pages/RiderEventSelectTest1";
import RiderEventSelectXandraHalloween from "./pages/RiderEventSelectXandraHalloween";
import RiderEventSelectBellThursdays from "./pages/RiderEventSelectBellThursdays";
import RiderEventSelectEmpireBasel from "./pages/RiderEventSelectEmpireBasel";
import RiderQuote from "./pages/RiderQuote";
import RiderLanding from "./pages/RiderLanding";
import RiderCheckout from "./pages/RiderCheckout";
import RiderTripSuccess from "./pages/RiderTripSuccess";
import RiderTripThankYou from "./pages/RiderTripThankYou";
import RiderMyTrips from "./pages/RiderMyTrips";
import RiderLogin from "./pages/RiderLogin";
import ModifyTrip from "./pages/ModifyTrip";
import Review from "./pages/Review";
import OperatorTripList from "./pages/OperatorTripList";
import { useAuth } from "./contexts/AuthContext";

const queryClient = new QueryClient();

// Protected route component
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) return <div>Loading...</div>;
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<RiderLanding />} />
      <Route path="/driver-landing" element={<DriverLanding />} />
      <Route path="/register" element={<Register />} />
      <Route path="/register-new" element={<RegisterNew />} />
      <Route path="/login" element={<Login />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/vehicle-registration" element={<VehicleRegistration />} />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/account" element={
        <ProtectedRoute>
          <Account />
        </ProtectedRoute>
      } />
      <Route path="/driver-trip-sync" element={
        <ProtectedRoute>
          <DriverTripSync />
        </ProtectedRoute>
      } />
      <Route path="/modify-trip" element={
        <ProtectedRoute>
          <ModifyTrip />
        </ProtectedRoute>
      } />
      <Route path="/rider-event-select" element={<RiderEventSelect />} />
      <Route path="/rider-event-select-breakaway" element={<RiderEventSelectBreakaway />} />
      <Route path="/rider-event-select-breakaway-v2" element={<RiderEventSelectBreakawayV2 />} />
      <Route path="/event-fisher-1" element={<RiderEventSelectFisher1 />} />
      <Route path="/test-event-1" element={<RiderEventSelectTest1 />} />
      <Route path="/xandra-halloween" element={<RiderEventSelectXandraHalloween />} />
      <Route path="/bell-thursdays" element={<RiderEventSelectBellThursdays />} />
      <Route path="/empire-basel" element={<RiderEventSelectEmpireBasel />} />
      <Route path="/we-belong-here-miami" element={<RiderEventSelectWeBelongHereMiami />} />
      <Route path="/rider-quote" element={<RiderQuote />} />
      <Route path="/rider-checkout" element={<RiderCheckout />} />
      <Route path="/rider-trip-success" element={<RiderTripSuccess />} />
      <Route path="/rider-trip-thank-you" element={<RiderTripThankYou />} />
      <Route path="/rider-my-trips" element={<RiderMyTrips />} />
      <Route path="/rider-login" element={<RiderLogin />} />
      <Route path="/review" element={<Review />} />
      <Route path="/operator-trip-list" element={
        <ProtectedRoute>
          <OperatorTripList />
        </ProtectedRoute>
      } />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster />
        <Sonner />
      </BrowserRouter>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
